import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showRank?: boolean;
  rank?: number;
}

export function ComicCard({ comic, showRank = false, rank }: ComicCardProps) {
  return (
    <a
      href={`/comic/${comic.id}`}
      className="group block"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={comic.cover}
          alt={`${comic.title} - 韩漫画免费在线阅读`}
          title={`${comic.title} - 韩漫全集大全`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {showRank && rank && (
          <div className="absolute top-2 left-2 w-7 h-7 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-sm font-bold">
            {rank}
          </div>
        )}
        <div className="absolute top-2 right-2">
          {comic.status === '已完结' ? (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-full whitespace-nowrap">
              完结
            </span>
          ) : (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-full whitespace-nowrap">
              连载
            </span>
          )}
        </div>
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
        {comic.title}
      </h3>
      <div className="flex items-center gap-2 text-xs text-foreground-500">
        <span>{comic.author}</span>
        <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
        <span>{comic.category}</span>
      </div>
    </a>
  );
}